import React from 'react';

interface Props {
  color?: string;
}

const IndicatorPending: React.FC<Props> = ({ color = '#21272E' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill={color} fillRule="nonzero">
        <g>
          <g>
            <path d="M17.637 22.844c1.195 0 1.91-.657 1.91-1.922v-.305c.012-3.234-3.434-5.86-4.945-7.289-.422-.398-.645-.762-.645-1.289 0-.527.223-.879.645-1.289 1.5-1.453 4.945-3.914 4.945-7.277V3.19c0-1.265-.715-1.921-1.91-1.921H6.257c-1.171 0-1.816.656-1.816 1.816v.387c0 3.363 3.446 5.824 4.957 7.277.422.41.645.762.645 1.29 0 .526-.223.89-.645 1.288-1.511 1.43-4.957 4.055-4.957 7.29v.41c0 1.16.645 1.816 1.817 1.816h11.379zm-1.114-1.606H7.477c-.563 0-.739-.62-.188-1.031l4.008-2.988c.129-.106.2-.176.2-.352V11.23c0-.632-.13-.949-.575-1.324-.668-.562-1.934-1.453-2.508-2.261-.234-.329-.21-.598.082-.598h6.996c.293 0 .317.27.082.598-.574.808-1.828 1.699-2.508 2.261-.445.375-.574.692-.574 1.324v5.637c0 .176.07.246.2.352l4.019 2.988c.55.41.363 1.031-.188 1.031z" transform="translate(-36 -362) translate(16 342) translate(20 20)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IndicatorPending;
